
import * as AspectRatioPrimitive from "@radix-ui/react-aspect-ratio"

// Export the AspectRatio component directly
const AspectRatio = AspectRatioPrimitive.Root

export { AspectRatio }
